<script setup lang="ts">
import SectionHeading from '@/components/SectionHeading.vue';

// Дата последнего обновления сведений на сайте (п. 4.5 Инструкции № 495)
const updatedAt = '01.10.2026';
</script>

<template>
  <!-- п. 4.5. Бухгалтерская (финансовая) отчётность -->
  <section class="section-tinted">
    <div class="container-narrow">
      <SectionHeading
        title="Бухгалтерская (финансовая) отчётность"
        lead="Лизинговая организация раскрывает годовую бухгалтерскую (финансовую) отчётность и аудиторское заключение в случаях, когда проведение аудита является обязательным."
      />
      <div class="grid grid-cols-2">
        <div class="card">
          <h4 class="card__title-md">Годовая бухгалтерская (финансовая) отчётность</h4>
          <p class="card__text">
            Будет размещена по итогам отчётного года не позднее 30 апреля года, следующего за отчётным.
          </p>
        </div>
        <div class="card">
          <h4 class="card__title-md">Аудиторское заключение</h4>
          <p class="card__text">
            Размещается вместе с годовой отчётностью при обязательности проведения аудита — не позднее 30 апреля года, следующего за отчётным.
          </p>
        </div>
      </div>
      <p class="field-hint docs-note">
        Отчётность по МСФО не составляется.
      </p>
    </div>
  </section>

  <!-- Актуальность информации -->
  <section>
    <div class="container-narrow">
      <SectionHeading
        eyebrow="Актуальность"
        title="Актуальность информации"
        lead="Сведения на сайте поддерживаются в актуальном состоянии в следующие сроки."
      />
      <div class="grid grid-cols-3">
        <div class="card">
          <p class="field-hint">Бухгалтерская (финансовая) отчётность</p>
          <p class="stat-value">не позднее 30 апреля года, следующего за отчётным</p>
        </div>
        <div class="card">
          <p class="field-hint">Иная информация, подлежащая раскрытию</p>
          <p class="stat-value">в течение 5 рабочих дней со дня изменения</p>
        </div>
        <div class="card">
          <p class="field-hint">Дата последнего обновления сведений</p>
          <p class="stat-value">{{ updatedAt }}</p>
        </div>
      </div>
    </div>
  </section>
</template>
